/*
 * Verschiebt die kompakte Google-Bewertung direkt unter den Produkttitel.
 * Das Markup wird serverseitig ausgegeben (crawlbar) und hier nur umgehaengt,
 * damit die grosse main-product.liquid nicht angefasst werden muss.
 */
(function () {
  function placeBadge() {
    var badges = document.querySelectorAll('.google-rating-badge');

    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];

      if (badge.dataset.placed === 'true') continue;

      var scope =
        badge.closest('.product__info-container') ||
        badge.closest('product-info') ||
        badge.closest('.product');

      if (!scope) continue;

      var title = scope.querySelector('.product__title');
      if (!title) continue;

      title.insertAdjacentElement('afterend', badge);
      badge.dataset.placed = 'true';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeBadge);
  } else {
    placeBadge();
  }

  // Quick-Add-Modal und Varianten-Wechsel laden Markup nach
  document.addEventListener('shopify:section:load', placeBadge);
  window.addEventListener('load', placeBadge);
})();
